import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Two business things Slovenia needs to change",
  "description": "",
  "published": "2012-02-15T00:00:00.000Z",
  "redirect_from": ["/blog/two-business-things-slovenia-needs-to-change/swizec/3668"],
  "categories": "Business, Education, Former Yugoslavia, News agency, Slavery, Slovenia, Student, Student Unions, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`This post is aimed at my local readers, the rest can look at it as a curiosity from an awesome small country that is fumbling all over itself trying to be even awesomer.`}</p>
    <h2 {...{
      "id": "slave-labor"
    }}>{`Slave labor`}</h2>
    <p>{`We don't have Mexicans, but we do have `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Student",
        "title": "Student"
      }}>{`students`}</a>{`. A whole `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Caste",
        "title": "Caste"
      }}>{`social caste`}</a>{` of people ripe for abuse because they don't realize their worth and hey, what better way to keep operating costs low than to employ a bunch of these guys, pay them below-minimum wage and tell them it's even worse elsewhere?`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/4296232936_fb73460a56_m12.jpg",
        "alt": "Students in the incubation room at the Woodbin...",
        "title": "Students in the incubation room at the Woodbin..."
      }}></img></p>
    <p>{`Not cool!`}</p>
    <p>{`Originally student work was invented to give students some degree of autonomy, to make getting through college cheaper and easier. It's since been quite corrupted ... whole companies running on nothing but `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Slavery",
        "title": "Slavery"
      }}>{`slave labor`}</a>{`.`}</p>
    <p>{`My recent survey about `}<a parentName="p" {...{
        "href": "http://swiz.ec/yhzzr7"
      }}>{`how much money comp sci students make`}</a>{` shows that most make less than 10 euro an hour, glaringly obvious even on just a cursory glance.`}</p>
    <p>{`These aren't internships mind you. A lot of them are full blown computer engineers, often-times making companies' core products completely on their own or with a help of a couple other students.`}</p>
    <p>{`It's sickening.`}</p>
    <p>{`Even worse is that when I published the survey, a lot of students pinged me and said `}<em parentName="p">{`"Hey, don't you think you set the bar somewhat high? Most of us don't even make the 7 euro lower bound you set up ..."`}</em></p>
    <p>{`No, for fuck's sake no! This is money we're talking about! You shouldn't be paid how much everyone else is being paid, this isn't some competition in fairness, this is cold hard cash! Demand to be fucking paid how much you are worth to the company.`}</p>
    <p>{`I can (sort of) understand a waiter working for 4 or 5 euro an hour. But anyone paying less than 10 for any nongeneric type of service should be laughed out of business.`}</p>
    <p>{`And `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Businessperson",
        "title": "Businessperson"
      }}>{`business people`}</a>{` ... shame on you!`}</p>
    <p>{`If you get a student who is any good and they timidly ask for 7 euro an hour because they consider that quite a bit of money. Tell them they're being stupid and demand to give them 15 euro. Congratulations, you just earned an extremely happy and loyal worker. And it's still cheaper than giving them full employment.`}</p>
    <p>{`When paying students, always keep in mind they rarely work more than half-time. They need to make a living off this!`}</p>
    <h2 {...{
      "id": "speed-of-business"
    }}>{`Speed of business`}</h2>
    <p>{`Another thing that really gets on my nerves in Slovenia is that everything is `}<em parentName="p">{`so slow`}</em>{`. Sending an invoice to a client in Slovenia feels like sending it down a black hole.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/02/2342478549_6175f46fd8_m13.jpg",
        "alt": "Invoice, Chas M Stieff Manufacturer of Grand &...",
        "title": "Invoice, Chas M Stieff Manufacturer of Grand &..."
      }}></img></p>
    <p>{`The average response time I've experienced is ... `}<em parentName="p">{`a long time`}</em>{`. Hell, I am legally mandated to give you two weeks of time to pay up and most `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Business",
        "title": "Business"
      }}>{`businesses`}</a>{` are very `}{`_`}{`very `}{`_`}{`careful not to pay anything sooner than that. The problem is so big the only thing `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Students%27_union",
        "title": "Students' union"
      }}>{`student unions`}</a>{` do is make sure people get paid quickly by just fronting the cash.`}</p>
    <p>{`I checked. There are `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Invoice",
        "title": "Invoice"
      }}>{`invoices`}</a>{` from `}<em parentName="p">{`a year ago`}</em>{` that are still marked as "fronted by student union".`}</p>
    <p>{`Sickening!`}</p>
    <p>{`You know what happens when you send an invoice to a proper country? You get paid the next day. Last night someone wired me the money literally 20 minutes after I clicked `}<em parentName="p">{`send`}</em>{` on the invoice email.`}</p>
    <p>{`Of course then I had to wait roughly 15 hours for my bank to actually process the transfer of a few electrons ...`}</p>
    <h2 {...{
      "id": "conclusion"
    }}>{`Conclusion`}</h2>
    <p>{`Slovenia is awesome and I love it to bits, but I sure as hell get the feeling it doesn't want me here. And hey, the top of the crop of our entrepreneurs, businesses and pretty much anyone worth their salt ... is leaving.`}</p>
    <p>{`I wonder why.`}</p>
    <p>{`PS: if looking at the data from that survey makes me any angrier I will hurt people.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.businessinsider.com/the-only-island-in-slovenia-may-be-the-most-awesome-private-island-in-the-world-2012-2"
        }}>{`The Only Island In Slovenia May Be The Most Awesome Private Island In The World`}</a>{` (businessinsider.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://studenteventsblog.wordpress.com/2012/02/06/student-unions/"
        }}>{`Student Unions`}</a>{` (studenteventsblog.wordpress.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.prweb.com/releases/2011/7/prweb8649378.htm"
        }}>{`Slo(www)Bus for Playful Exploration of Slovenia`}</a>{` (prweb.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://seattletimes.nwsource.com/html/nationworld/2016937139_apeusloveniawomenmps.html?syndication=rss"
        }}>{`Record number of women in Slovenia parliament`}</a>{` (seattletimes.nwsource.com)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=51092f8d-c661-4e48-aea8-c95c26dac146",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      